import {Injectable} from '@angular/core';
import {HttpService, QueryModel} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponseList} from '../../models/response/response.model';
import {PatientFile} from '../../models/patient-file/patient-file.model';

@Injectable({
    providedIn: 'root'
})
export class UploadService extends HttpService {

    uploadFile(file: File, documentType: string | null = null, patientId: string | null = null): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        if (documentType) {
            formData.append('documentType', documentType);
        }
        if (patientId) {
            formData.append('patientId', patientId);
        }
        return this.formDataPost('files', formData).pipe(
            map((response: any) => {
                return response;
            })
            , catchError(error => {
                throw error
            })
        )
    }

    uploadIDFiles(frontFile: File, backFile: File, patientId: string | null = null): Observable<any> {
        const formData = new FormData();
        formData.append('front', frontFile);
        formData.append('back', backFile);

        if (patientId) {
            formData.append('patientId', patientId);
        }

        return this.formDataPatch(`patients/${patientId}/id-documents`, formData).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error;
            })
        );
    }

    getFiles(query: QueryModel): Observable<iResponseList<PatientFile>> {
        return this.get(`files`, query).pipe(
            map((response: iResponseList<PatientFile>) => {
                return response;
            })
            , catchError(error => {
                throw error
            })
        )
    }

    getFile(fileId: string, query: QueryModel): Observable<any> {
        return this.get(`files/${fileId}`, query).pipe(
            map((response: any) => {
                return response;
            })
            , catchError(error => {
                throw error
            })
        )
    }

    downloadFile(fileId: string, fileName: string, contentType: string): void {
        this.download(`files/${fileId}`, fileName, contentType);
    }

    downloadWithQuery(fileId: string, fileName: string, contentType: string, query: QueryModel): void {
        this.download(`files/${fileId}`, fileName, contentType, query);
    }

    deleteFile(fileId: string): Observable<any> {
        return this.delete(`files/${fileId}`).pipe(
            map((response: any) => {
                return response;
            })
            , catchError(error => {
                throw error
            })
        )
    }

    setFilePermissions(fileId: string, doctorId: string): Observable<any> {
        return this.post(`files/${fileId}/permissions`, {doctorId: doctorId}).pipe(
            map((response: any) => {
                return response;
            })
            , catchError(error => {
                throw error
            })
        )
    }

    deleteFilePermissions(fileId: string, filePermissionsId: string): Observable<any> {
        return this.delete(`files/${fileId}/permissions/${filePermissionsId}`).pipe(
            map((response: any) => {
                return response;
            })
            , catchError(error => {
                throw error
            })
        )
    }


}
